import { GetStaticPaths, GetStaticProps } from "next";
import BlogIndexPage from "@/components/BlogIndex/BlogIndexPage";
import { getBlogPostsForCategory } from "@/utils/getBlogItems";
import fetchContentfulGraphql from "@/utils/contentfulGraphql";

const Page = ({ ...props }: any) => {
  return <BlogIndexPage {...props} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const { data } = await fetchContentfulGraphql(`{
    blogCategoryCollection {
      items {
        slug
        linkedFrom {
            blogPostCollection {
                total
            }
        }
      }
    }
  }`);

  const paths: any[] = [];
  data.blogCategoryCollection.items.forEach((item: any) => {
    paths.push({ params: { category: item.slug } });
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  return {
    props: await getBlogPostsForCategory(ctx.params!.category as any, 1),
  };
};

export default Page;
